var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H14C15.1046 22 16 21.1046 16 20V15H14V20H4V4L14 4V9H16V4C16 2.89543 15.1046 2 14 2H4Z",
    fill: "#101D3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 11.4477 8.44772 11 9 11H19.5858L17.2929 8.70711C16.9024 8.31658 16.9024 7.68342 17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289L23.4142 12L18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071C16.9024 16.3166 16.9024 15.6834 17.2929 15.2929L19.5858 13H9C8.44772 13 8 12.5523 8 12Z",
    fill: "#101D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4111fccf46782f324b9ff159d2c87de9.svg";
export { ForwardRef as ReactComponent };